import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useErrorHandler } from "src/core/error/useErrorHandler";
import { useError } from "src/core/hooks/useError";
import { logService } from "src/core/services/logService";
import { useSettingsStore } from "src/features/settings/services/useSettingsStore";
import { useAppointmentStore } from "../../services/useAppointmentStore";
import "./AppointmentConfirmPage.css";

export function AppointmentConfirmPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getErrorMessage } = useError();

  const appointmentStore = useAppointmentStore();
  const settingsStore = useSettingsStore();
  const errorHandler = useErrorHandler();

  const [message, setMessage] = useState("");

  useEffect(() => {
    if ((settingsStore?.errorList?.errorCodes?.length ?? 0) === 0) return;

    const queryParams = new URLSearchParams(location.search);

    logService.log("AppointmentConfirmPage queryParams", queryParams);

    const id = queryParams.get("id");
    const key = queryParams.get("key");
    if (!id || !key) {
      errorHandler.setError({
        title: t("Home.Appointments.Title"),
        message: t("Home.Appointments.ConfirmError"),
      });

      navigate("/");
    } else {
      appointmentStore
        .appointmentConfirm(Number(id), key)
        .then(() => {
          setMessage(t("Home.Appointments.ConfirmSuccess"));
        })
        .catch((error) => {
          errorHandler.setError({
            title: t("Home.Appointments.Title"),
            message:
              t("Home.Appointments.ConfirmFailed") +
              " " +
              getErrorMessage(error),
          });

          navigate("/");
        });
    }
  }, [settingsStore.errorList]);

  return (
    <div className="appointmentConfirmPage">
      <div className="flex justify-content-center align-items-center p-2 pt-3">
        {appointmentStore.loading && (
          <span className="flex align-items-center gap-2 text-xl font-bold">
            <i
              className="pi pi-spin pi-spinner"
              style={{ fontSize: "2rem" }}
            ></i>
            {t("Home.Appointments.ConfirmLoading")}
          </span>
        )}
        {!appointmentStore.loading && (
          <span className="text-2xl font-bold">{message}</span>
        )}
      </div>
    </div>
  );
}
